import { FoodsSelect, FoodsSelectProps } from "@foodpilot/foods";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Campaign } from "src/api/client-api/useCampaign";
import { useFoodpilotContext } from "src/context/FoodpilotContext";

type CampaignSelectorProps = {
    disableText?: boolean;
    textual?: boolean;
    BoxPropsOverride?: FoodsSelectProps<unknown>["BoxProps"];
    allCampaigns?: Campaign[];
    showFuture?: boolean;
};
export const CampaignSelector = (props: CampaignSelectorProps) => {
    const { disableText = false, textual = false, BoxPropsOverride = {}, allCampaigns, showFuture = false } = props;
    const { t } = useTranslation();
    const theme = useTheme();

    const { campaigns, currentCampaign, setCurrentCampaign } = useFoodpilotContext();

    const _campaignsToSelectFrom = allCampaigns ? allCampaigns : campaigns;

    const currentYear = new Date().getFullYear();
    const campaignsToSelectFrom = _campaignsToSelectFrom.flatMap((c) => {
        if (showFuture === true) {
            return [c];
        }

        const labelAsYear = Number(c.label);
        if (currentYear >= labelAsYear - 1) {
            return [c];
        }

        return [];
    });
    const select = (
        <FoodsSelect
            selectedOption={currentCampaign}
            options={campaignsToSelectFrom}
            onChange={(selectedCampaign) => setCurrentCampaign(selectedCampaign)}
            getId={(campaign) => campaign.id}
            getName={(campaign) => `${t("campaignselect.year", "Year:")} ${campaign.label}`}
            closeOnSelect
            disableSearch
            textOptions={{
                placeholder: t("component.select.placeholder"),
                searchPlaceholder: t("component.select.searchplaceholder"),
                emptyOptionsText: t("component.select.nooptions"),
                defaultValueText: t("component.select.defaultvalue"),
                noResult: t("component.select.noresultfound"),
            }}
            BoxProps={{
                width: textual ? "fit-content" : { xs: "110px", lg: "130px" },
                ...(textual ?
                    {
                        "& .MuiButtonBase-root": {
                            border: "none",
                            gap: theme.spacing(1),
                            height: "auto",
                        },
                        "& .MuiTypography-root": {
                            fontSize: theme.typography.h3.fontSize,
                        },
                    }
                :   {}),
                ...BoxPropsOverride,
            }}
        />
    );

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
            }}
        >
            {disableText === false && (
                <Typography
                    variant="h5"
                    sx={{
                        whiteSpace: "nowrap",
                        display: { xs: "none", lg: "block" },
                    }}
                >
                    {t("campaignselect.label")} :
                </Typography>
            )}
            {select}
        </Box>
    );
};
